export default  {"src":"/_next/static/image/public/assets/icons/close-white.24264c9ff5b4bb52d16c5eafdeb190c6.svg","height":15,"width":15};